export default {
  BACK: 0,
  MIDDLE: 1,
  FRONT: 2,
};

export const MAX_LEVELS = 3;
